import { render, staticRenderFns } from "./AiResultsList.vue?vue&type=template&id=f338489e&scoped=true"
import script from "./AiResultsList.vue?vue&type=script&lang=js"
export * from "./AiResultsList.vue?vue&type=script&lang=js"
import style0 from "./AiResultsList.vue?vue&type=style&index=0&id=f338489e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f338489e",
  null
  
)

export default component.exports